import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "../ui/card";
import { Button } from "../ui/button";
import { Skeleton } from "../ui/skeleton";
import { Pencil, Trash2, MessageCircle, TrendingUp } from "lucide-react";

const PredictorCards = ({ items, loading = false, onEdit, onDeleteRequest, seeCommentsOfAPredictor, seePredictionsOfAPredictor }) => {
    if (!loading && items.length === 0) return null;

    return (
        <div className="grid grid-cols-1 gap-4 md:hidden">
            {loading ? (
                Array.from({ length: 3 }).map((_, i) => (
                    <Card key={`skeleton-${i}`}>
                        <CardContent className="pt-6">
                            <Skeleton className="h-6 w-3/4 mb-2" />
                            <Skeleton className="h-4 w-1/2" />
                        </CardContent>
                    </Card>
                ))
            ) : (
                items.map((item) => (
                    <Card key={item.predictor_id}>
                        <CardHeader>
                            <CardTitle>{item.predictorname}</CardTitle>
                            <CardDescription>ID: {item.predictor_id}</CardDescription>
                        </CardHeader>
                        <CardContent>
                            <p className="text-sm text-muted-foreground">Score: {item.proficiency_score}</p>
                        </CardContent>
                        <CardFooter className="flex flex-wrap justify-end gap-2">
                            <Button variant="ghost" size="sm" onClick={() => seeCommentsOfAPredictor(item.predictor_id)}>
                                <MessageCircle className="h-4 w-4 mr-1" />
                                Commentaires
                            </Button>
                            <Button variant="ghost" size="sm" onClick={() => seePredictionsOfAPredictor(item.predictor_id)}>
                                <TrendingUp className="h-4 w-4 mr-1" />
                                Prédictions
                            </Button>
                            <Button variant="outline" size="sm" onClick={() => onEdit(item)}>
                                <Pencil className="h-4 w-4 mr-1" />
                                Modifier
                            </Button>
                            <Button variant="ghost" size="sm" className="text-destructive hover:text-destructive hover:bg-destructive/10" onClick={() => onDeleteRequest(item.predictor_id)}>
                                <Trash2 className="h-4 w-4 mr-1" />
                                Supprimer
                            </Button>
                        </CardFooter>
                    </Card>
                ))
            )}
        </div>
    );
};

export default PredictorCards;
